import { AccountGroupMembership } from '@libs/src/models/account.model';

export const enum ACCOUNT_PERMISSIONS {
  'dev_pro_admin' = 'dev_pro_admin',
  'hub_admin' = 'hub_admin',
  'tenant_admin' = 'tenant_admin',
  'member' = 'member',
}

export interface PermissionGroupSettings {
  groups: Pick<AccountGroupMembership, 'feature_admin' | 'isAdmin'>;
  isAdmin?: boolean;
}
